
import { configureStore } from "@reduxjs/toolkit"
import cartSlice  from "./cartslice"


export const store=configureStore({
    reducer:{
        cart:cartSlice
    }
})

